// Get file name from locale folder dynamic
export const getFileName = (lngValue = "") => {
  if (lngValue.match(/\ben\b|\bGB\b|\bUS\b/gi)) {
    return "gb";
  }
  if (lngValue.match(/\bsr\b|\bRS\b/gi)) {
    return "rs";
  }
  return "gb";
};

// Handle dictionary name
export const dicitonaryNameTranslated = (name, formatMessage) => {
  const splited = name.split(" - ");
  const firstValue = formatMessage({
    id: `LANGUAGE.${splited[0]}`,
    defaultMessage: "",
  });
  const secondValue = formatMessage({
    id: `LANGUAGE.${splited[1]}`,
    defaultMessage: "",
  });

  return `${firstValue} - ${secondValue}`;
};
